import { defineComponent, h } from 'vue';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';

export default defineComponent({
    name: 'form-section-dsgn',
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    methods: {
        ...methods,
        normalizeColumns(columns) {
            const parsed = Number(columns);
            if (!Number.isFinite(parsed))
                return 1;

            return Math.max(1, Math.floor(parsed));
        },
        buildSectionBody(elements, normalizedColumns) {
            if (normalizedColumns <= 1)
                return elements;

            const gridStyle = {
                display: 'grid',
                gridTemplateColumns: `repeat(${normalizedColumns}, minmax(0, 1fr))`,
                columnGap: '10px',
                rowGap: '10px',
                alignItems: 'start'
            };

            const cells = elements.map((element, index) => (
                <div key={element?.key || `section-cell-${index}`} class="form-section-grid-cell">
                    {element}
                </div>
            ));

            return (
                <div class="form-section-grid" style={gridStyle}>
                    {cells}
                </div>
            );
        },
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        designmodel: null,
        schema: null,
        form: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
        selected: null,
    },
    render() {
        try {
            const schema = utils.schema.resolve_Of(this.schema);
            const items = this.form?.items || [];
            const elements = items.map((s, index) => {
                let key = s?.key;

                const tagItem = utils.forms.getDesignerFormType(this, key ?? s, schema, s, this.cmodel);
                if (tagItem)
                    return (
                        <div key={s?.key || `section-item-${index}`}>
                            {tagItem}
                        </div>
                    );
                else
                    return (
                        <div key={s?.key || `section-item-${index}`} style="font-size: small;">
                            {s.title ? s.title : s.key}
                        </div>
                    );
            });
            const normalizedColumns = this.normalizeColumns(this.form?.ControlData?.columns);
            const sectionBody = this.buildSectionBody(elements, normalizedColumns);

            return (
                <div
                    class="designer-form"
                    style="flex-grow: 1; width: 100%; position: relative;"
                    onClick={(e) => this.handleClick(e)}>
                    <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                    <div style={{ flexDirection: "column" }}>
                        {sectionBody}
                    </div>
                </div>
            );
        }
        catch (err) {
            console.error('Render function exception in designer section.jsx', err);
            return <div>Error: {err.message}</div>;
        }
    }
});
